module.exports = __webpack_public_path__ + "img/tags.8ea85795.svg";